<div class="py-6 w-full text-sm font-['Roboto']">
  <div class="flex flex-col gap-4 w-full md:w-2/3">
    <div class="flex flex-row items-center justify-center sm:justify-start gap-4 sm:gap-6">
      <ln-logo-svg-icon
        [class]="
          'w-24 h-16 sm:w-40 sm:h-24 sm:hover:cursor-pointer hover:scale-110 transition-transform duration-300'
        "></ln-logo-svg-icon>
      <button (click)="navigateToLunaNuevaPropertiesWebPage()">
        <ln-properties-logo-svg-icon
          [class]="
          'w-24 h-16 sm:w-40 sm:h-24 sm:hover:cursor-pointer hover:scale-110 transition-transform duration-300'
        "></ln-properties-logo-svg-icon>
      </button>
      <button (click)="navigateToLunaNuevaPortalWebPage()">
        <ln-portal-logo-svg-icon
          [class]="
          'w-24 h-16 sm:w-40 sm:h-24 sm:hover:cursor-pointer hover:scale-110 transition-transform duration-300'
        "></ln-portal-logo-svg-icon>
      </button>

    </div>
  </div>

  <div class="flex flex-col justify-start md:flex-row md:justify-between md:items-center gap-2 sm:gap-6 w-full my-4">
    <div class="border-t sm:border-b py-4 border-rojo max-w-md">
      <p class="max-w-md text-cafe text-base font-normal font-['Roboto'] leading-normal">
        {{'components.LnFooterComponent.title' | transloco}}
      </p>
    </div>

    <div
      class="flex flex-row gap-2 sm:gap-6 text-cafe text-sm font-medium sm:text-lg sm:font-normal font-['Roboto'] w-full md:w-auto">
      <button (click)="navigateToContactPage()" class="flex flex-col hover:font-bold">{{'buttons.contactUs' | transloco}}</button>
      <button (click)="navigateToServicesPage()" class="flex flex-col hover:font-bold">{{'buttons.services' | transloco}}</button>
      <div class="flex flex-col">
        <button (click)="navigateToAboutUsPage()" class="flex flex-col hover:font-bold">{{'buttons.aboutUs' | transloco}}</button>
        <button class="hidden sm:block self-end hover:scale-110 transition-transform duration-300 mt-2"
                *transloco="let t"
                (click)="navigateToWhatsapp(t('messages.lunaNuevaPortalContact'))">
          <ln-whatsapp-svg-icon class="w-6 h-6" fillColor="#577778"></ln-whatsapp-svg-icon>
        </button>
      </div>
      <div class="flex flex-col">
      <button class="hover:font-bold" (click)="navigateToLunaNuevaBlog()">
        {{'buttons.blog' | transloco}}
      </button>
        <button class="hidden sm:block self-end hover:scale-110 transition-transform duration-300 mt-2"
                *transloco="let t"
                (click)="navigateToInstagram(t('messages.lunaNuevaPortalContact'))
                ">
          <ln-instagram-svg-icon class="w-6 h-6" fillColor="#B79086"></ln-instagram-svg-icon>
        </button>
      </div>
    </div>

    <div
      class="block sm:hidden flex-row  w-full mt-[8px] ">

        <button class="hover:scale-110 transition-transform duration-300"
                *transloco="let t"
                (click)="navigateToWhatsapp(t('messages.lunaNuevaPortalContact'))">
          <ln-whatsapp-svg-icon class="w-6 h-6" fillColor="#577778"></ln-whatsapp-svg-icon>
        </button>

        <button class="ml-[19px] hover:scale-110 transition-transform duration-300"
                *transloco="let t"
                (click)="navigateToInstagram(t('messages.lunaNuevaPortalContact'))">
          <ln-instagram-svg-icon class="w-6 h-6" fillColor="#B79086"></ln-instagram-svg-icon>
        </button>

    </div>

  </div>

  <div class="max-w-lg">
    <button
      (click)="navigateToSeizaWebPage()"
      (mouseenter)="onHover()"
      (mouseleave)="onLeave()"
      class="cursor-pointer"
    >
      <p class="text-cafe text-sm font-normal sm:text-base  font-['Roboto'] leading-normal mt-2 text-start hover:font-bold"
         [ngClass]="seizaWordMouseHover() ? 'text-lg' : ''"
      >
        {{'components.LnFooterComponent.developedBy' | transloco}}
        <span
          class=" text-lg font-bold cursor-pointer"
          [ngClass]="seizaWordMouseHover() ? 'text-red-500' : 'text-rojo'"
        >♥</span
        >
        {{'components.LnFooterComponent.rightReserved' | transloco}}
      </p>
    </button>
  </div>
</div>
